import   React                            ,
       { useState                         ,
         useEffect                        ,
         useRef                           }  from "react";

import   classNames                          from "classnames";

import   styles                              from "./DailyRevenue.module.scss";

import   AnimatedWaitingIcon                 from '../../../widget/animations/animatedWaitingIcon';
import   VerticalLabel                       from '../../../widget/dataDisplay/labels/VerticalLabel';

import { getTurnoverAndPaymentCountByDate }  from '../../../../backendServices/paymentManagment/api';
		 

const DailyRevenue: React.FC = () => {



  const [ showWaitingIcon , setShowWaitingIcon ] = useState(false);

  const [ dailyRevenue    , setDailyRevenue    ] = useState (0)

  const intervalRef    = useRef<NodeJS.Timeout | null>(null);

  const fetchData = async () => {
	  
    try 
     {
      setShowWaitingIcon(true);

      const getTurnoverAndPaymentCountByDateResponse = await getTurnoverAndPaymentCountByDate(new Date())

      const revenue = getTurnoverAndPaymentCountByDateResponse.code === 1 ? getTurnoverAndPaymentCountByDateResponse.payload.turnover : 0;

      setDailyRevenue (revenue);
     } 
	catch (error) 
	 {
      console.error("Erreur lors de la récupération des sessions :", error);
     }
	 
    setShowWaitingIcon(false);
  };

  useEffect(() => {

    fetchData(); 

    intervalRef.current = setInterval(fetchData, 60000); // 60000 milliseconds = 1 minute

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current); // Nettoyage de l'intervalle lors du démontage du composant
      }
    };
  }, []);

  const renderDailyRevenue = () : JSX.Element => {

    return <>

         <VerticalLabel label      = {<>CA<br/>du jour</>}
                        value      = { `${(dailyRevenue/100).toFixed(2)} €` }
                        width      = "100%"
                        sizeLabel  = {12}
                        sizeValue  = {16}
                        colorValue = "var(--color-Text-FG-emphasized)" />

    </>
  }


  return (
    
      <div className={classNames(styles.root)}>

        <div className={classNames(styles.overlay)}>
		  {showWaitingIcon && <AnimatedWaitingIcon />}
        </div>
	  
        {renderDailyRevenue()}
		
      </div>

  );
};

export default DailyRevenue;
